import React from 'react';
import CustomReactSelect from "v4/components/form/Field/components/CustomReactSelect/CustomReactSelect";
import AdminListEditor from "v4/features/admin/adminForms/components/AdminListEditor/AdminListEditor";
import useQuoteState from "v4/features/admin/adminForms/components/QuoteState/hooks/useQuoteState";

export default function QuoteState({ rawValuesFromAdmin }) {
    const {
        fields,
        handleSubmit,
        register,
        onDelete,
        onAdd,
        onExtraChange,
        fieldName,
        quoteStateStatusOptions,
        showReasons,
        getQuoteStateReasonsOptions,
    } = useQuoteState(rawValuesFromAdmin);

    return (
        <AdminListEditor
            title="QuoteState"
            fields={fields}
            handleSubmit={handleSubmit}
            register={register}
            onDelete={onDelete}
            onAdd={onAdd}
            fieldName={fieldName}
            renderItemExtras={(input, index) => (
                <div className="admin-list__extras">
                    <CustomReactSelect name={`${fieldName}.${index}.extra.quoteStateStatus`}
                                       value={input.extra.quoteStateStatus ?? []}
                                       options={quoteStateStatusOptions}
                                       isMulti
                                       onChange={onExtraChange(index, 'quoteStateStatus')}/>

                    {showReasons && (
                        <CustomReactSelect name={`${fieldName}.${index}.extra.quoteStateReasons`}
                                           value={input.extra.quoteStateReasons ?? []}
                                           options={getQuoteStateReasonsOptions(index)}
                                           isMulti
                                           selectParams={{ closeMenuOnSelect: true }}
                                           onChange={onExtraChange(index, 'quoteStateReasons')}/>
                    )}
                </div>
            )}
        />
    );
}
